/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Why_LeadInputs */

const en_coaches_page_why_lead = /** @type {(inputs: Coaches_Page_Why_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book in a minute.`)
};

const pl_coaches_page_why_lead = /** @type {(inputs: Coaches_Page_Why_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwujesz w minutę.`)
};

/**
* | output |
* | --- |
* | "Book in a minute." |
*
* @param {Coaches_Page_Why_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_why_lead = /** @type {((inputs?: Coaches_Page_Why_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Why_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_why_lead(inputs)
	return en_coaches_page_why_lead(inputs)
});